import { render, staticRenderFns } from "./ordersPacking.vue?vue&type=template&id=0ffd3e62"
import script from "./ordersPacking.vue?vue&type=script&lang=js"
export * from "./ordersPacking.vue?vue&type=script&lang=js"
import style0 from "./ordersPacking.vue?vue&type=style&index=0&id=0ffd3e62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports